import { Resource, ResourceType } from "@istari-frontend/resource/model";
import { V3Models } from "@istari/istari-client";

import { stripExtensionFromDisplayName } from "~/utils/file";

import { toInfosecLevel } from "./to-infosec-level";
import { toResourceType } from "./to-resource-type";
import { toToken } from "./to-token";
import { toUpstreamRemote } from "./to-upstream-remote";

export function toResource(dto: V3Models.ResourceDto): Resource {
  const typeName = toResourceType(dto.resourceType);
  return {
    id: dto.resourceId,
    typeName,
    createdAt: dto.created,
    updatedAt: dto.updated,
    archived: dto.archived,
    fileId: dto.fileId,
    createdById: dto.createdById,
    infosecLevel: toInfosecLevel(dto.infosecLevel),
    controlTags: dto.controlTags,

    // Latest revision data
    revisionId: dto.fileRevisionId,
    displayName: stripExtensionFromDisplayName(dto.displayName ?? dto.name, dto.extension),
    description: dto.description ?? undefined,
    name: dto.name ?? undefined,
    extension: dto.extension ?? undefined,
    size: dto.size ?? undefined,
    mime: dto.mime ?? undefined,
    contentToken: toToken(dto.contentToken),
    propertiesToken: toToken(dto.propertiesToken),

    // External props - maybe we can consolidate them as one object
    upstreamRemote: dto.upstreamRemote ? toUpstreamRemote(dto.upstreamRemote) : undefined,
    externalIdentifier: dto.externalIdentifier ?? undefined,
    hasChildren: dto.hasChildren ?? undefined,
    tombstoned: dto.tombstoned ?? false,
    // A connected container expands to what it holds, in a filtered list as in its band.
    isContainer: typeName === ResourceType.ConnectedContainer,
  };
}
